export const USER_ACTION = { GUEST_LOGIN: 'guestLogin', WX_LOGIN: 'wxLogin' }
